import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {RootState} from "../../store/store";
import {NavItem} from "../components/FormNav/NavItem";

export interface FormNavigationState {
    activeNavItem: NavItem | undefined,
    saveClicked: boolean,
    visitedNavItems: NavItem[]
}

const initialState: FormNavigationState = {
    activeNavItem: undefined,
    saveClicked: false,
    visitedNavItems: []
};

const navigationSlice = createSlice({
    name: "navigation",
    initialState,
    reducers: {
        setActiveNavItem: (state, action: PayloadAction<NavItem | undefined>) => {
            state.activeNavItem = action.payload;
            if(action && action.payload !== undefined) {
                navigationSlice.caseReducers.markVisitedStep(state, action)
            } else {
                navigationSlice.caseReducers.resetVisitedNavItems(state)
            }
        },
        setSaveClicked: (state, action: PayloadAction<boolean>) => {
            state.saveClicked = action.payload
        },
        markVisitedStep: (state, action: PayloadAction<NavItem | undefined>) => {
                state.visitedNavItems.push(action.payload!);
        },
        resetVisitedNavItems: (state) => {
            state.visitedNavItems = [];
        }
    }
})

export const {
    setActiveNavItem,
    setSaveClicked,
    markVisitedStep,
    resetVisitedNavItems
} = navigationSlice.actions;

export const navItemSelector = (state: RootState) => state.estateFlowchart.navigation.activeNavItem;
export const saveSelector = (state: RootState) => state.estateFlowchart.navigation.saveClicked;
export const visitedNavsSelector = (state: RootState) => state.estateFlowchart.navigation.visitedNavItems;


export default navigationSlice.reducer